var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-13',{staticClass:"border-box-container",attrs:{"color":_vm.color}},[(_vm.textContent)?[_c('span',{style:(_vm.style)},[_vm._v(_vm._s(_vm.textContent))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }